<template>
  
  <div id="quotation-info" class="sixteen wide column">
    <div class="ui segment">
      <h4 class="ui dividing header">Dados do Orçamento</h4>
      <form class="ui form">
        <div class="fields">
          <div class="four wide field" :class="{ disabled: productInputVisible }">
            <label class="form-label">Tipo <span class="red text">*</span></label>
            <select id="select-type" class="ui fluid dropdown" v-model="type">
              <option value="">Selecione...</option>
              <option value="1"><i class="file blue text icon"></i> Orçamento</option>
              <option value="2"><i class="shopping cart green text icon"></i> Pedido</option>
              <option value="3"><i class="gift red text icon"></i> Bonificação</option>
            </select>
          </div>
          <div class="three wide field">
            <label class="form-label">Emissão</label>
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :value="$formatDate(date)" readonly="readonly">
            </div>
          </div>
          <div class="three wide field">
            <label class="form-label">Validade</label>
            <div v-if="quotation.isOwner || isCreating" class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :value="$formatDate(validDate)" readonly="readonly">
            </div>
            <div v-else id="valid-date" class="ui calendar">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input class="date">
              </div>
            </div>
          </div>
          <div class="six wide field">
            <label class="form-label">Responsável</label>
            <input type="text" :value="userName" readonly="readonly">
          </div>
        </div>
        <div v-if="showBillingInfo" class="fields">
          <div class="six wide field">
            <label class="form-label">Fil. Faturamento</label>
            <input type="text" :value="quotation.customer.billBranchDesc" readonly="readonly">
          </div>
          <div class="three wide field">
            <label class="form-label">ICMS</label>
            <input type="text" :value="icmsDisplay" readonly="readonly">
          </div>
          <div class="three wide field">
            <label class="form-label">Divide Pedido</label>
            <input type="text" :value="divideOrderDisplay" readonly="readonly">
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  import { Calendar, moment } from "@/utils"

  export default {

    data() {
      return {        
        loading: true,
        type: "",
        date: null,
        validDate: null,
        userName: "",
      }
    },
    
    props: ["quotation", "isCreating", "isUpdating", "productInputVisible"],

    computed: {
      showBillingInfo() {
        const c = this.quotation && this.quotation.customer
        return c && c.code && c.code !== '000000' && !c.isProspect && c.billBranchDesc
      },
      icmsDisplay() {
        const c = this.quotation && this.quotation.customer
        return (c && c.icmsRate) ? c.icmsRate + '%' : ''
      },
      divideOrderDisplay() {
        const c = this.quotation && this.quotation.customer
        if (!c || typeof c.divideOrder !== 'boolean') return ''
        return c.divideOrder ? 'Sim' : 'Não'
      }
    },

    watch: {

      "type" () {
        this.onChange()
      },

      "validDate" () {
        this.onChange()
      }
    },

    created() {

      if (this.isCreating) {
        this.date = new Date()
        this.userName = this.$store.state.user.name
      } else {
        this.type = this.quotation.type
        this.date = this.quotation.date
        this.validDate = this.quotation.validDate
        this.userName = this.quotation.nameUser
      }
    },

    mounted() {

      $("#select-type").dropdown()
      
      if (this.isUpdating)
        $("#select-type").dropdown("set selected", this.type)

      Calendar.init("#valid-date", {
        onChange: (date, text) => this.validDate = date,
      })      
      
      if (this.quotation.isApprover) 
        $("#valid-date").calendar("set date", moment(this.validDate).toDate())

      setTimeout(() => this.loading = false, 1000)  
    },

    methods: {
      
      onChange() {

        if (this.loading)
          return

        this.$emit("onChange", { type: this.type, validDate: this.validDate })
      }
    },
  }

</script>

